<template>
    <section 
    class="sectioncontrol" 
    style="background-color: whitesmoke;" 
    :class="{'contsectionrightcss' :contsectionrighttheme==='contsectionrightcss'}"
    >
        
      <div class="container-fluid"> 
        <div class="row confrow">
            <div class="col-xs-12 col-sm-12 col-md-8">
                <div class="lefttextformat" v-show="showleftdesc===true">
                    <div v-html="confleftdesc" >

                    </div>

                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4">
                <img :src="confimage" class="sectionimage">
                <div class="boxdata">
                    <div  class="slide-info shadow">
                        <div  class="spantext">
                            <p class="">{{ confshortdesc }}</p>
                            <p class="desctext" v-html="confdesc"></p>
                        </div>
                    </div>
                </div>
            </div>
          </div>
      </div>
        
    </section>
    
        </template>
        
        <script>
     
        export default {
          props: ['confimage', 'confshortdesc', 'confdesc', 'confleftdesc', 'showleftdesc', 'contsectionrighttheme'],         
        }
        </script>
        
    <style scoped>
    .newslearnmore {
        float: right; 
        padding-right: 30px;
    }
  
    .sectionimage {
        height: 100%;
        width: 100%;
        z-index: 1;
    }
    .boxdata{
        position: relative;
        width: 380px;
        height: 320px;
        margin-top: -280px;
        margin-right: 50px;
        float: right;
        border: solid orange thick;
        z-index: 1;
    }
    .slide-info {
        background-color: white;
      
        margin-top: 10px;
        margin-left: -20px;
        width: 380px;
        height:290px;
        border-radius: 5px;
    }
    .spantext {
        padding-left: 30px;
        padding-right: 30px;
        padding-top: 20px;
        padding-bottom: 20px;
        
    }
  
    .desctext{
        font-size: 20px;
    }
  
  
  .slide-info {
      background-color: white;
      position: relative;
      margin-top: 10px;
      margin-left: 10px;
  
      width: 350px;
      height: auto;
      border-radius: 5px;
  }
  .boxdata{
      position: relative;
      width: 350px;
      height: auto;
      margin-top: -30px;
      margin-left: 40px;
  
      float: left;
      border: solid orange thick;
      z-index: 1;
  }
  .sectionimage {
      height: 200px;
      width: 100%;
      z-index: 1;
  }
  .lefttextformat {
    padding: 100px;
  }
 
  
  /*===================MEDIA SCREENS TAMPLATES===============*/
   /* Extra small devices (phones, 600px and down) */
   @media only screen and (max-width: 600px) {
      .boxdata{
          position: relative;
          margin-left: 14px;
          width: 350px;
          height: auto;
          margin-top: 30px;
      }
      .slide-info {
          margin-left: 10px;
          width: 310px;
          height: auto;
          margin-bottom: 10px;
          
  
      }
   }
  
  @media only screen and (max-width: 360px) {
      .boxdata{
          position: relative;
          margin-left: 14px;
          width: 300px;
          height: auto;
          margin-top: 30px;
      }
      .slide-info {
          margin-left: 10px;
          width: 280px;
          height: auto;
          margin-bottom: 10px;
      }

   }
  
   /* Small devices (portrait tablets and large phones, 600px and up) */
   @media only screen and (min-width: 600px) {
      .sectioncontrol {
          margin-top: 20px;
      }
      .slide-info {
          background-color: white;
          position: relative;
          margin-top: 10px;
          margin-left: 10px;
      
          width: 350px;
          height:290px;
          border-radius: 5px;
      }
      .boxdata{
          position: relative;
          width: 350px;
          height: 320px;
          margin-top: -30px;
          margin-left: 180px;
      
          float: left;
          border: solid orange thick;
          z-index: 1;
      }
      .sectionimage {
          height: 200px;
          width: 100%;
          z-index: 1;
      }
   }
   
   /* Medium devices (landscape tablets, 768px and up) */
   @media only screen and (min-width: 768px) {
      .slide-info {
          background-color: white;
          position: relative;
          margin-top: 10px;
          margin-left: 0px;
          width: 350px;
          height:290px;
          border-radius: 5px;
      }
    .col-md-8 {
        width: 100%;
    }
    .col-md-4 {
        width: 100%;
        padding-bottom: 100px;
    }
   }
   
   /* Large devices (laptops/desktops, 992px and up) */
   @media only screen and (min-width: 992px) {
  
   }
   
   /* Extra large devices (large laptops and desktops, 1200px and up) */
   @media only screen and (min-width: 1200px) {
      .slide-info {
          background-color: white;
          position: relative;
          margin-top: 10px;
          margin-left: -20px;
          width: 350px;
          height:290px;
          border-radius: 5px;
      }
      .sectionimage {
          height: 300px;
          width: 100%;
          z-index: 1;
      }
      .boxdata{ 
          margin-top: -130px;
          float: right;
      }

   } 

      /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {

        .col-md-4{ 
            margin-top: -50px;
        }
  
     } 
    </style>